import { computed, effect, Injectable, signal, Signal, WritableSignal } from '@angular/core';

interface UserMetadata {
  creationTime: string | undefined;
  lastSignInTime: string | undefined;
}

export interface UserState {
  displayName: string | null;
  email: string | null;
  emailVerified: boolean;
  isAnonymous: boolean;
  metadata: UserMetadata | { creationTime: undefined; lastSignInTime: undefined } | null;
  phoneNumber: string | null;
  photoURL: string | null;
}


@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private _User: WritableSignal<UserState> = signal<UserState>({
    displayName: null,
    email: null,
    emailVerified: false,
    isAnonymous: false,
    metadata: null,
    phoneNumber: null,
    photoURL: null
  });

  private createStateLogger<T>(signal: Signal<T>, label: string = 'State'): void {
    let previousValue: T | undefined;

    effect(() => {
      const newValue = signal();
      console.group(`[StateLogger] ${label}`);
      console.log('New Value:', newValue);
      console.groupEnd();
      previousValue = newValue;
    });
  }

  constructor() { 
    this.createStateLogger(this._User, 'User');
  }

  get User() {
    return this._User;
  }

  setUser(user: UserState) {
    this._User.set(user);
  }

  get loggedIn(): Signal<boolean> {
    return computed(() => {
      return this._User().email !== null;
    });
  }
}
